import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { FloatingShapes } from './shared/FloatingShapes';
export function Mission() {
  return <section className="relative w-full overflow-hidden bg-ink py-20 lg:py-28" data-id="element-218">
      <FloatingShapes data-id="element-219" />
      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8" data-id="element-220">
        <motion.span initial={{
        opacity: 0,
        scale: 0.7
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mx-auto mb-8 flex h-16 w-16 items-center justify-center rounded-full bg-gold-gradient text-white shadow-gold" data-id="element-221">
          <QuoteIcon className="h-7 w-7" data-id="element-222" />
        </motion.span>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-4 flex items-center justify-center gap-3" data-id="element-223">
          <span className="h-px w-8 bg-gold" data-id="element-224" />
          <span className="text-xs font-semibold uppercase tracking-[0.28em] text-gold-light" data-id="element-225">
            Naša misija
          </span>
          <span className="h-px w-8 bg-gold" data-id="element-226" />
        </motion.div>

        <motion.blockquote initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="font-display text-2xl font-medium leading-snug text-white text-balance sm:text-3xl lg:text-4xl" data-id="element-227">
          Pružiti porodicama sigurnost i mir, a njegovateljima priliku za
          profesionalan angažman kroz{' '}
          <span className="italic text-gold" data-id="element-228">
            odgovorno, transparentno i kvalitetno
          </span>{' '}
          posredovanje.
        </motion.blockquote>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mx-auto mt-8 max-w-2xl text-base text-white/60 sm:text-lg" data-id="element-229">
          Golden Care — Povjerenje koje spaja ljude i kvalitetnu njegu.
        </motion.p>
      </div>
    </section>;
}